module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-footer-fixed-btn"
  }, [_c('x-button', {
    staticClass: "com-btn-submit-radius",
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkEvent($event)
      }
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49272e80"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/baseComponents/SubmitButton.vue
// module id = 1047
// module chunks = 1